import i18n from '@/libs/i18n'

/*
 * Sistem tanımlarının slug → id eşlemesi (#143). Kaynak: BE #72 migration
 * (`wf-migrations/2026_11_02_definition_slugs.sql`). İş mantığı slug ile karşılaştırır;
 * BE'ye giden kayıt ve filtre değerleri id'yi buradan alır.
 * subtask `not_completed` soft-delete edildi (WF-17), eski kayıtlar için duruyor.
 */
export const DEFINITION_IDS = {
  task: {
    open: 1, in_progress: 2, completed: 3, cancelled: 4,
  },
  subtask: {
    open: 1, completed: 2, manager_cancelled: 3, not_completed: 4,
  },
  project: { open: 1, completed: 2, cancelled: 3 },
  priority: {
    low: 1, medium: 2, high: 3, critical: 4,
  },
}

export function definitionId(type, slug) {
  return DEFINITION_IDS[type]?.[slug] ?? null
}

// id → slug ters eşlemesi, modül yüklenirken bir kez kurulur.
export const DEFINITION_SLUGS = Object.fromEntries(
  Object.entries(DEFINITION_IDS).map(([type, map]) => [
    type,
    Object.fromEntries(Object.entries(map).map(([slug, id]) => [id, slug])),
  ]),
)

export function definitionSlug(type, id) {
  return DEFINITION_SLUGS[type]?.[Number(id)] ?? null
}

/*
 * Kaydın durum slug'ı. Önce id'den türetilir: formda veya kayıttan sonra yerelde
 * değişen alan id'dir, BE'nin döndüğü `<type>_status_slug` eski kalabilir.
 */
export function statusSlug(type, item) {
  if (!item) return null
  return definitionSlug(type, item[`id_${type}_statuses`]) || item[`${type}_status_slug`] || null
}

/*
 * Sistem tanımı etiketi (durum, öncelik) slug'dan çevrilir (BE #72).
 * Slug yoksa veya çevirisi yoksa BE'nin Türkçe başlığı yedek kalır.
 */
export function definitionLabel(type, slug, fallback = '—') {
  const key = `statuses.${type}.${slug}`
  return slug && i18n.te(key) ? i18n.t(key) : (fallback || '—')
}

/*
 * Yetki ekranı adları (BE #80): grup `main_group_slug`, alt grup `subgroup_slug`,
 * yetki `subject`'in son parçasından (TEAM_LIST → list). Çevirisi yoksa BE metni kalır.
 */
export function abilityLabel(kind, key, fallback = '—') {
  const path = `abilities.${kind}.${key}`
  return key && i18n.te(path) ? i18n.t(path) : (fallback || '—')
}

export function abilityAction(subject) {
  return subject ? subject.split('_').pop().toLowerCase() : null
}

export default definitionLabel
